import { Alert, Button, Card, Col, Form, message, Row } from 'antd'
import { $error, setGateway, submitSaveCommission } from '../../model'
import { PlusSquareOutlined } from '@ant-design/icons'
import * as React from 'react'
import { Gateway } from '../../types'
import { useStore } from 'effector-react'
import { CommissionFormItem } from './commissionFormItem'

export enum CommissionType {
  Calculated = 'calculated',
  Vendor = 'vendor',
  Custom = 'custom',
  KoraVat = 'kora_vat',
  KoraLimit = 'kora_limit',
}

type Props = {
  gateway: Gateway
  loading: boolean
  handleCommissionChange: (index: number, objectKey: string, value: any) => void
  submitSaveQueue: <F extends (...args: any[]) => void, A extends any[]>(
    objects: A,
    func: F,
  ) => void
}

export const CommissionFormComponent: React.FC<Props> = ({
  gateway,
  loading,
  handleCommissionChange,
  submitSaveQueue,
}) => {
  const error = useStore($error)

  return (
    <>
      <strong>Commissions:</strong>
      {error.message.length > 0 && (
        <Alert
          type="error"
          message={`Error: ${error.message}`}
          style={{ marginBottom: 16 }}
        />
      )}
      <Form layout="vertical">
        <Row gutter={[16, 16]} align="middle" style={{ marginBottom: 16 }}>
          {gateway.gatewayCommissions.map((element, index) => (
            <CommissionFormItem
              key={index}
              element={element}
              index={index}
              loading={loading}
              handleCommissionChange={handleCommissionChange}
            />
          ))}
          <br />
          {gateway.gatewayCommissions.length < 9 && (
            <Col>
              <Card
                style={{
                  width: 108,
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
                onClick={() => {
                  setGateway({
                    ...gateway,
                    gatewayCommissions: [
                      ...gateway.gatewayCommissions,
                      {
                        isLocal: true,
                        gatewayId: gateway.gatewayId,
                        operationType: '',
                        payer: '',
                        commissionType: '',
                        flatAmount: '0',
                        flatCurrency: '0',
                        percentAmount: '0',
                        minAmount: '0',
                        minCurrency: '0',
                        maxAmount: '0',
                        maxCurrency: '0',
                        customParams: {},
                        acquirer: 'inner',
                        isEstimated: false,
                      },
                    ],
                  })
                }}
              >
                <h1>
                  <PlusSquareOutlined className={'summary'} />
                </h1>
              </Card>
            </Col>
          )}
        </Row>
      </Form>
      <Button
        type="primary"
        style={{ marginLeft: 8 }}
        disabled={loading}
        onClick={() => {
          const hasInvalidKoraLimit = gateway.gatewayCommissions.some(
            (commission) =>
              commission.commissionType === CommissionType.KoraLimit &&
              commission.acquirer !== 'vendor',
          )
          if (hasInvalidKoraLimit) {
            message.error(
              'Kora limit commission type is only available with Vendor acquirer',
            )
            return
          }
          submitSaveQueue(gateway.gatewayCommissions, submitSaveCommission)
        }}
      >
        Update commissions
      </Button>
    </>
  )
}
